import { LinerTypeBase } from './base/liner-type-base';

export class LinerType extends LinerTypeBase { }